import React, { useEffect, useState, useRef, useMemo} from 'react';

import {Container, Modal, Row, Col, Button} from "react-bootstrap";
import { useSelector } from "react-redux";
import moment from "moment/moment";
import TimePicker from "rc-time-picker";
import ARBResponseListener from '../../components/Controls/ARBResponseListener.js';

import '../../assets/Styles/ActivateTripCSS/ActivateTripCSS.css';
import "rc-time-picker/assets/index.css";

import DateTimeControl from '../Controls/DateTimePicker.js';
import APICom from "../../utils/helpers/APICom.js";
import DateTimeUtils from "../../utils/DateTimeUtility.js";
import BuildManifest from './BuildManifest.js';
import ConfirmationModal from "../Controls/ConfirmationModal";

const ActivateTrip = (props) => {

  const requestTimeRef = useRef();
  const requestApptRef = useRef();

  const { loginData }  = useSelector((store) => store.login);
  const { ASCSSettingData }  = useSelector((store) => store.combinedata);

  // --- FIX: keep showActivateTripDialog driven by prop initial value
  const [showActivateTripDialog, setShowActivateTripDialog] = useState(props.showActivateDialog);

  const [activateTripObj, setActivateTripObj] = useState({
    iATSPID : '-1',
    ServiceID: '-1',
    ConfirmationNo:'',
    OriginalTime: '',
    OriginalAppt: '',
    RequestDate:'', // keep MM/DD/YYYY here (used for API)
    RequestTime: null, // moment object for TimePicker
    RequestAppt: null,
    iAssignedVehicleID: -1
  });

  // --- FIX: keep date states as strings in YYYY-MM-DD format because inputs expect that
  const [originalDate, setOriginalDate] = useState(moment().format("YYYY-MM-DD"));
  const [requestedDate, setRequestedDate] = useState(moment().format("YYYY-MM-DD"));

  const [nb10, setNb10] = useState(600);

  // --- FIX: keep requestedTime/requestedAppt as simple strings (not objects)
  const [requestedTime, setRequestedTime] = useState('');   // ex: '02:30 PM'
  const [requestedAppt, setRequestedAppt] = useState('');   // ex: '03:00 PM'

  const [showActivationAlert, setShowActivationAlert] = useState(false);
  const [activateAlert, setActivateAlert] = useState({alertTitle: '', alertMsg:''});

  const [TableHeaders, setTableHeaders] = useState(["Confirmation#","Orig. DateTime","Orig. Appt. Time", "Req DateTime", "Req Appt. Time"]);
  const [showActivationMultiple, setShowActivationMultiple] = useState(false);

  // --- FIX: tripsInfo should be an array
  const [tripsInfo, setTripsInfo] = useState([]);
  const [TripActivationChanges, setTripActivationChanges] = useState([]);
  const [failAlert, setFailAlert] = useState(false);
  const calendarRestriction = useRef(null);

  const [triggerRouteSuggestion, settriggerRouteSuggestion] = useState(false);
  const [triggerUnRoute, setTriggerUnRoute] = useState(false);
  const [showManifestBuildDialog, setManifestBuildDialog] = useState(false);
  const [selectRowData, setSelectedRowData] = useState([]);
  const [route, setRoute] = useState("");
  const [addTripToRoute, setAddTripToRoute] = useState(false);
  const [showRouteSuggestionActionCreate, setRouteSuggestionActionCreate] = useState(false);
  const [GridRefreshPaused, setGridRefreshPaused] = useState(false);
  const [selectedDate,setSelectedDate]=useState("");
  const [selectedAffiliate,setselectedAffiliate]=useState("");
  const [TimeTakenByLastGridCall, setTimeTakenByLastGridCall] = useState(0);
  const RefSelectedDate = useRef();
  
  const [confirmationModalObjReRouting, setConfirmationModalObjReRouting] = useState({
        show: false, title: 'Re-Routing',
        body: 'Confirm activation of the Noshow routed trip: press Yes to Unroute & adjust to the same route, or press No to keep it unrouted.', btnCanceText: 'No',
        btnOkText: 'Yes'
  });
  const [confirmationModalObjTripActivationRefusal, setConfirmationModalObjTripActivationRefusal] = useState({
        show: false, title: 'Trip Activation',
        body: 'Please Select One Trip at a time.', btnCanceText: 'No',
        btnOkText: 'OK'
  });
  const [confirmationModalObjReRoutingConfirmation, setConfirmationModalObjReRoutingConfirmation] = useState({
        show: false, title: 'Trip Activation',
        body: 'Re-Routing/Un-Routing Successful,', btnCanceText: 'No',
        btnOkText: 'OK'
  });

  useEffect(() => {
    const allEqual = arr=> arr.every(v=> v===arr[0]);
    if(!props.GridRowData || props.GridRowData.length <=0)
    {
      setActivateAlert({...activateAlert, alertTitle: 'No trip selected', alertMsg:'Please select a trip to activate.'});
      setShowActivationAlert(true);
      return;
    }

    if(props.GridRowData.length > 1)
    {
      // multiple selection flow
      let tripActivationInfo = [];
      setTripsInfo(props.GridRowData); // tripsInfo is array now
      let tripsStatus = [];
      for(let l = 0; l < props.GridRowData.length; l++)
      {
        tripsStatus.push(props.GridRowData[l].TripRequestStatus.toUpperCase());
      }
      
      if(allEqual(tripsStatus) && (tripsStatus[0] === "CANCELLED" || tripsStatus[0] === "NOSHOW"))
      {
        for(let i = 0; i < props.GridRowData.length; i++)
        {
          const standardTime = (props.GridRowData[i].PickupDateTime.split(" ")[parseInt(props.GridRowData[i].PickupDateTime.split(" ").length-1)]);
          const militaryTime = DateTimeUtils.toMilitaryTime(standardTime);

          let requestDateTemp = props.GridRowData[i].PickupDateTime.split(" ")[0];
          requestDateTemp = requestDateTemp.split("/");
          const correctYearFormat = (requestDateTemp[2]+"-"+(parseInt(requestDateTemp[0]) < 10 ? "0" + parseInt(requestDateTemp[0]) : requestDateTemp[0]) + "-" +
            (parseInt(requestDateTemp[1]) < 10 ? "0" + parseInt(requestDateTemp[1]):requestDateTemp[1])
          );
          // --- push the fields expected by UI: requestedDate should be YYYY-MM-DD for <input type="date">
          tripActivationInfo.push({
            requestedDate: correctYearFormat,
            requestedTime: militaryTime,          // 'HH:mm' 24-hour (input type time expects 'HH:mm')
            requestedApptTime: props.GridRowData[i].ApptTime || ''
          });
        }
        let todayDt = new Date(),
        month = todayDt.getMonth()+1,
        day = todayDt.getDate(),
        year = todayDt.getFullYear();
        if(month < 10) month = '0'+month.toString();
        if(day < 10) day = '0' + day.toString();

        let minDate = year + '-' + month + '-' + day;
        calendarRestriction.current = minDate;
        setTripActivationChanges(tripActivationInfo);
        setShowActivationMultiple(true);
        setShowActivateTripDialog(true);
      }
      else
      {
        setActivateAlert({...activateAlert, alertTitle: 'Trip Selection Alert', alertMsg:'Please select a trip with the status CANCELLED or NOSHOW only.'});
        setShowActivationAlert(true);
      }
      return;
    }

    // single selection flow
    const selected = props.GridRowData[0];
    if(selected.TripRequestStatus.toUpperCase() === "CANCELLED" || selected.TripRequestStatus.toUpperCase() === "NOSHOW")
    {
      // read Nb10 from ASCSSettingData if present
      if (ASCSSettingData !== null && ASCSSettingData !== undefined)
      {
          if (ASCSSettingData.hasOwnProperty(selected.iSRATSPID)) {
            try {
              const jsonArray = JSON.parse(ASCSSettingData[selected.iSRATSPID]);
              jsonArray.forEach(item => {
                if(item.SubTitle === "Nb10"){
                  setNb10(item.value);
                }
              });
            } catch(e) {
              // parse fail: leave default nb10
            }
          }
      }

      // compute original datetime and request + nb10
      let OrginalDateTime = moment(selected.PickupDateTime, 'MM/DD/YYYY hh:mma');
      // add nb10 seconds to original
      let RequestTimePlusNb10 = moment(selected.PickupDateTime, 'MM/DD/YYYY hh:mma').add(nb10, 'seconds');

      let _NewApptDateTime = null;
      if(selected.ApptTime && selected.ApptTime !== "")
      {
        let _OrigApptDateTime = moment(selected.PickupDateTime.split(' ')[0] + ' ' + selected.ApptTime, 'MM/DD/YYYY hh:mma').add(nb10, 'seconds');
        _NewApptDateTime = _OrigApptDateTime;
      }

      // --- IMPORTANT FIXES:
      // 1) keep input date strings as YYYY-MM-DD for the <input type="date" />
      // 2) keep activateTripObj.RequestDate as MM/DD/YYYY (this was used downstream for building activation datetime in original code)
      setActivateTripObj((prevState) => ({
        ...prevState,
        iATSPID: selected.iSRATSPID,
        ServiceID: selected.ServiceID,
        ConfirmationNo: selected.ConfirmationNo,
        OriginalTime: moment(OrginalDateTime, 'hh:mm A'),
        OriginalAppt: (selected.ApptTime === "") ? "" : moment(selected.ApptTime, 'hh:mm A'),
        RequestDate: RequestTimePlusNb10.format('MM/DD/YYYY'), // for API
        RequestTime: RequestTimePlusNb10, // moment
        RequestAppt: (_NewApptDateTime === null) ? null : _NewApptDateTime,
        iAssignedVehicleID: selected.iAssignedVehicleID
      }));

      // set the input field values (YYYY-MM-DD strings)
      setOriginalDate(OrginalDateTime.format('YYYY-MM-DD'));       // for <input type="date" />
      setRequestedDate(RequestTimePlusNb10.format('YYYY-MM-DD'));  // for <input type="date" />

      // set requestedTime/requestedAppt as strings used in validation and API assembly
      setRequestedTime(RequestTimePlusNb10.format('hh:mm A'));            // e.g. "02:30 PM"
      setRequestedAppt(_NewApptDateTime ? _NewApptDateTime.format('hh:mm A') : '');

      setShowActivateTripDialog(true);
    }
    else
    {
      setActivateAlert({...activateAlert, alertTitle: 'Trip Selection Alert', alertMsg:'Please select a trip with the status CANCELLED or NOSHOW only.'});
      setShowActivationAlert(true);
    }
  }, []); // intentionally run once on mount (kept same as original)

  // Handle date input change: input provides YYYY-MM-DD -> keep the same for the UI input,
  // but if you need to update activateTripObj.RequestDate (MM/DD/YYYY for API), convert it there as needed.
  const handleRequestDateChange = (dateString) => {
    // dateString is like '2025-11-20' coming from <input type="date" />
    setRequestedDate(dateString);
    // Also update activateTripObj.RequestDate in MM/DD/YYYY format for the API when needed:
    const dt = moment(dateString, 'YYYY-MM-DD');
    if (dt.isValid()) {
      setActivateTripObj(prev => ({ ...prev, RequestDate: dt.format('MM/DD/YYYY') }));
    }
  };

  // TimePicker onChange will pass a moment object
  const handleRequestTimeChange = (Time) => {
    if(Time !== null)
    {
      setRequestedTime(Time.format('hh:mm A'));
      setActivateTripObj((prevState) => ({...prevState, RequestTime: Time}));
    }
    else{
      setRequestedTime('');
      setActivateTripObj((prevState) => ({...prevState, RequestTime: null}));
    }
  };

  const handleRequestApptChange = (Appt) => {
    if(Appt !== null)
    {
      setRequestedAppt(Appt.format('hh:mm A'));
      setActivateTripObj((prevState) => ({...prevState, RequestAppt: Appt}));
    }
    else
    {
      setRequestedAppt('');
      setActivateTripObj((prevState) => ({...prevState, RequestAppt: null}));
    }
  };

  // --- FIX: In multiple select UI, treat TripActivationChanges as an array and update immutably
  const handleSelectionChange = (index, key, selection) => {
    try{
      setTripActivationChanges(prevState=>{
        const newState = Array.isArray(prevState) ? [...prevState] : [];
        // ensure item exists
        const item = newState[index] ? { ...newState[index] } : {};
        item[key] = selection;
        newState[index] = item;
        return newState;
      });
    }
    catch(err){console.log(err);}
  };

  const handleOkActivateTripDialog = async() => {
    try{
      if(props.GridRowData.length > 1){
        // refuse multi-activate unless specific condition met
        setConfirmationModalObjTripActivationRefusal((prevState) => ({ ...prevState, show: true}));
        return false;
      }

      if(props.GridRowData.length > 1)
      {
        // original multi-activation implementation kept with minimal type corrections...
        // NOTE: this block likely won't be hit because we early-return above, left here for parity
        let confirmationFlag = false;
        for(let i in TripActivationChanges)
        {
          // ... omitted for brevity (original logic uses TripActivationChanges)
        }
        if(confirmationFlag)
        {
          setActivateAlert({...activateAlert, alertTitle: 'Action Successful', alertMsg:'Trips activated successfully.'});
          setShowActivationAlert(true);
          return false;
        }
      }
      else
      {
        // single trip activation flow: build activation object and call API
        // Build appointment datetime string if appointment provided
        let ApptDT = (requestedAppt === "")? "" : activateTripObj.RequestDate + " " + requestedAppt;
        if(ApptDT !== "")
        {
          let ReqDT = activateTripObj.RequestDate + " " + requestedTime; // requestedTime is 'hh:mm A' string
          if(ReqDT !== '' && moment(ReqDT, 'MM/DD/YYYY hh:mma').isAfter(moment(ApptDT, 'MM/DD/YYYY hh:mma')))
          {
            setActivateAlert({...activateAlert, alertTitle: 'Action Failed', alertMsg:'Schedule time cannot be greater than appointment time.'});
            setShowActivationAlert(true);
            return false;
          }
          else if(ReqDT !== '' && moment(ReqDT, 'MM/DD/YYYY hh:mma').isSame(moment(ApptDT, 'MM/DD/YYYY hh:mma')))
          {
            setActivateAlert({...activateAlert, alertTitle: 'Action Failed', alertMsg:'Schedule time cannot be same as appointment time.'});
            setShowActivationAlert(true);
            return false;
          }
        }

        let actObj = {"ServiceID": "-1", "iATSPID" : "-1", "iUserID": "-1", "activationDateTime" : '', "activationApptDateTime" : ''};
        actObj["ServiceID"] = activateTripObj.ServiceID.toString();
        actObj["iATSPID"] = activateTripObj.iATSPID.toString();
        actObj["iUserID"] = loginData.iUserID;
        // activationDateTime expects MM/DD/YYYY hh:mm A (based on original usage)
        actObj["activationDateTime"] = activateTripObj.RequestDate + " " + requestedTime;
        actObj["activationApptDateTime"] = (requestedAppt === "") ? "" : (activateTripObj.RequestDate + " " + requestedAppt);
        actObj["iAppID"] = "26";

        let response = await APICom.fetchData("", "TripActions/PerformActivate", "post", { "Content-Type": "application/json" }, actObj, null);
        let result = response.data;
        if(Number(result.rowcount) > 0)
        {
          if(props?.GridRowData[0]?.vManifestNumber ===""){
          setActivateAlert({...activateAlert, alertTitle: 'Action Successful', alertMsg:'Trip activated successfully.'});
          setShowActivationAlert(true);
          }

          if(props?.GridRowData[0]?.vManifestNumber !== ""){
            setConfirmationModalObjReRouting((prevState) => ({ ...prevState, show: true}));
          }
          return false;
        }
        else
        {
          setActivateAlert({...activateAlert, alertTitle: 'Action Failed', alertMsg:'Trip activation failed.'});
          setShowActivationAlert(true);
          return false;
        }
      }
    }
    catch(err){
      console.log(err);
      setActivateAlert({...activateAlert, alertTitle: 'Action Failed', alertMsg: 'Unexpected error.'});
      setShowActivationAlert(true);
    }
  };

  const handleCloseActivateTripDialog = () => {
    setShowActivateTripDialog(false);
    UnMountActivateTripComponent();
  };

  const handleAlertModalClose = () => {
    setShowActivationAlert(false);
    if(!failAlert)
    {
      UnMountActivateTripComponent();
    }
  };

  const UnMountActivateTripComponent = () => {
    if(props.showActivateDialog)
    {
      props.setShowActivateDialog(false);
    }
  };

  const handleFilteringConfirmNum = (e)=>{
    try{
      let elements = document.getElementsByClassName('TripsActivationList');
      for(var k = 0; k < elements.length; k++)
      {
          if(!elements[k].children[0].textContent.toLowerCase().includes(e.target.value.toLowerCase()))
          {
            elements[k].style.display = "none";
          }
          else
          {
            elements[k].style.display = "table-row";
          }
      }
    }
    catch(err){console.log(err);}
  };

  const handleConfirmationModalReRoutingCancel = () => {
    setConfirmationModalObjReRouting((prevState) => ({ ...prevState, show: false}));
    setSelectedRowData(props.GridRowData);
    setRoute("");
    setAddTripToRoute(false);
    const s = props?.GridRowData[0]?.vManifestNumber?.substring(0, 8);
    const affno=props?.GridRowData[0]?.vManifestNumber?.substring(8, 11);
    const yyyy = s.slice(0, 4);
    const mm   = s.slice(4, 6);
    const dd   = s.slice(6, 8);
    const formattedDate = `${yyyy}-${mm}-${dd}`;
    setSelectedDate(formattedDate);
    setselectedAffiliate(affno);
    settriggerRouteSuggestion(false);
    setTriggerUnRoute(true);
    setManifestBuildDialog(true);
  };
  const handleConfirmationModalReRoutingOk = () => {
    setConfirmationModalObjReRouting((prevState) => ({ ...prevState, show: false}));
    setSelectedRowData(props.GridRowData);
    setRoute(props?.GridRowData[0]?.vManifestNumber);
    setAddTripToRoute(true);
    const s = props?.GridRowData[0]?.vManifestNumber?.substring(0, 8);
    const affno=props?.GridRowData[0]?.vManifestNumber?.substring(8, 11);
    const yyyy = s.slice(0, 4);
    const mm   = s.slice(4, 6);
    const dd   = s.slice(6, 8);
    const formattedDate = `${yyyy}-${mm}-${dd}`;
    setSelectedDate(formattedDate);
    setselectedAffiliate(affno);
    setManifestBuildDialog(true);
  };
  const handleConfirmationModalReRoutingClose = () => {
    setConfirmationModalObjReRouting((prevState) => ({ ...prevState, show: false}));
  };

  const handleConfirmationModalObjTripActivationRefusalCancel = () => {
    setConfirmationModalObjTripActivationRefusal((prevState) => ({ ...prevState, show: false}));
  };
  const handleConfirmationModalObjTripActivationRefusalOk = () => {
    setConfirmationModalObjTripActivationRefusal((prevState) => ({ ...prevState, show: false}));
  };
  const handleConfirmationModalObjTripActivationRefusalClose = () => {
    setConfirmationModalObjTripActivationRefusal((prevState) => ({ ...prevState, show: false}));
  };
  const onDialogStateChange = (newState) => {
  if (newState === false) {
    console.log("manifestBuildDialog has been set to false from ARBResponseListener");
   // setShowActivationMultiple(false);
   
    setConfirmationModalObjReRoutingConfirmation((prevState) => ({ ...prevState, show: true}));
    // Add any other action you'd like to take here
  }
};
  const handleConfirmationModalReRoutingConfirmationOk = () => {setConfirmationModalObjReRoutingConfirmation((prevState) => ({ ...prevState, show: false}));};
  const handleConfirmationModalReRoutingConfirmationClose = () => {setConfirmationModalObjReRoutingConfirmation((prevState) => ({ ...prevState, show: false}));};
  const handleConfirmationModalReRoutingConfirmationCancel = () => {setConfirmationModalObjReRoutingConfirmation((prevState) => ({ ...prevState, show: false}));};

    const ARBResponseListenerMemo = useMemo(() =>
        <ARBResponseListener

            setManifestBuildDialog={setManifestBuildDialog}
            onDialogStateChange={onDialogStateChange}
        // StopViewGridLoad={() => StopViewGridLoad(_vManifestNumber.current, _iAffilaiteID.current)}
        />,
        [
            setManifestBuildDialog]
    )
  // --- FIX: parentheses around status check to avoid precedence issues
  const shouldShowModal = showActivateTripDialog && props.GridRowData.length > 0 &&
    (props.GridRowData[0].TripRequestStatus.toUpperCase() === "CANCELLED" ||
     props.GridRowData[0].TripRequestStatus.toUpperCase() === "NOSHOW");

  return(
    <>
                {
                ARBResponseListenerMemo
            }
      { shouldShowModal ?
        <Modal size='lg' show={showActivateTripDialog} centered onHide={()=>setShowActivateTripDialog(false)} aria-labelledby="contained-modal-title-vcenter" keyboard={true} backdrop="static" animation={true}>
          <Modal.Header className='activate_dialog_header_bgcolor' closeButton onClick={handleCloseActivateTripDialog}>
            <Modal.Title className="activate_dialog_title_color user-select-none" id="contained-modal-title-vcenter">
              Trip Activation
            </Modal.Title>
          </Modal.Header>

          {showActivationMultiple ? 
            <Modal.Body className="grid-example">
              <Row className="overflow-auto" style={{height:"150px"}}>
                <Col className="justify-content-center">
                  <table className="border border-dark" >
                    <thead>
                        <tr className="text-center text-nowrap">
                            {TableHeaders.map((head, headID) =>{
                                if(head === "Confirmation#")
                                {
                                  return <th className="border border-dark p-1 user-select-none" key={headID}>{head}<input type="text" placeholder="" onKeyUp={handleFilteringConfirmNum} className="d-block w-100 text-center"/></th>;
                                }
                                else
                                {
                                  return <th className="border border-dark p-1 user-select-none" key={headID}>{head}</th>;
                                }
                            })}
                        </tr>
                    </thead>
                    <tbody>
                      {tripsInfo.map((item, index)=>(
                          <tr key={index} className="text-center TripsActivationList">
                            <td className="border border-dark user-select-none">{item.ConfirmationNo}</td>
                            <td className="border border-dark user-select-none p-1 text-nowrap">{item.PickupDateTime}</td>
                            <td value={item.ApptTime} className="border border-dark user-select-none">{item.ApptTime === null || item.ApptTime === "" ? "N/A":item.ApptTime}</td>
                            <td className="border border-dark">
                              <input
                                min={calendarRestriction.current}
                                type="date"
                                className="text-center d-inline-flex my-1"
                                onChange={(e)=>handleSelectionChange(index, "requestedDate", e.target.value)}
                                value={TripActivationChanges[index]?.requestedDate || ''}
                              />
                              <input
                                type="time"
                                className="d-inline-flex text-center my-1"
                                value={TripActivationChanges[index]?.requestedTime || ''}
                                onChange={(e)=>handleSelectionChange(index, "requestedTime", e.target.value)}
                              />
                            </td>
                            <td className="border border-dark user-select-none">
                              <input
                                className="text-center"
                                value={TripActivationChanges[index]?.requestedApptTime || ''}
                                type="time"
                                onChange={(e)=>handleSelectionChange(index, "requestedApptTime", e.target.value)}
                              />
                            </td>
                          </tr>
                      ))}
                    </tbody>
                  </table>
                </Col>
              </Row>
            </Modal.Body>
          
          :<Modal.Body className="grid-example">
            Are you sure to activate Trip# <b>{activateTripObj.ConfirmationNo}</b> for the request date & time?
            <Container>
            <Row>
              <Col xs={6} md={3}>&nbsp;</Col>
              <Col xs={6} md={3}>&nbsp;</Col>
              <Col xs={6} md={2} style={{fontWeight: "bold"}}>Req. Time</Col>
              <Col xs={6} md={2} style={{fontWeight: "bold"}}>Appt. Time</Col>
            </Row>

            <Row>
              <Col xs={6} md={3} style={{fontWeight: "bold"}}>Original DateTime</Col>
              <Col xs={6} md={3}>
                {/* originalDate is YYYY-MM-DD string */}
                <input type="date" name="dateGiven" autoComplete="new_pass"
                  value={originalDate}
                  onChange={(e) => setOriginalDate(e.target.value)}
                  className="original-datetime-input" style={{ minWidth: "120px", maxHeight: "30px", height: "30px" }}
                  min={moment().format("YYYY-MM-DD")} disabled
                />
              </Col>
              <Col xs={6} md={2}>
                <TimePicker value={activateTripObj.OriginalTime} disabled showSecond={false} allowEmpty format={"hh:mm A"} use12Hours  />
              </Col>
              <Col xs={6} md={2}>
                <TimePicker value={activateTripObj.OriginalAppt} disabled showSecond={false} allowEmpty format={"hh:mm A"} use12Hours  />
              </Col>
            </Row>

            <Row>
              <Col xs={6} md={3} style={{fontWeight: "bold"}}>Request DateTime</Col>
              <Col xs={6} md={3}>
                {/* requestedDate is YYYY-MM-DD string for the input */}
                <input type="date" name="dateGiven" autoComplete="new_pass" value={requestedDate}
                  onChange={(e) => handleRequestDateChange(e.target.value)}
                  className="requested-datetime-input" style={{ minWidth: "120px", maxHeight: "30px", height: "30px" }}
                  min={moment().format("YYYY-MM-DD")}
                />
              </Col>
              <Col xs={6} md={2}>
                <TimePicker value={activateTripObj.RequestTime} onChange={handleRequestTimeChange} showSecond={false} allowEmpty format={"hh:mm A"} use12Hours ref={requestTimeRef} clearIcon={false} />
              </Col>
              <Col xs={6} md={2}>
                <TimePicker value={activateTripObj.RequestAppt} onChange={handleRequestApptChange} showSecond={false} allowEmpty format={"hh:mm A"} use12Hours ref={requestApptRef} />
              </Col>
            </Row>
            </Container>
          </Modal.Body>}
          <Modal.Footer>
            <Button variant="dark" onClick={handleOkActivateTripDialog}>Yes</Button>
            <Button variant="secondary" onClick={handleCloseActivateTripDialog}>No</Button>
          </Modal.Footer>
        </Modal> : "" }

      { showActivationAlert &&
        <Modal centered show={showActivationAlert} onHide={handleAlertModalClose} backdrop="static" animation={true} >
          <Modal.Header className='activate_dialog_header_bgcolor' style={{height: "50px"}} closeButton>
            <Modal.Title className='activate_dialog_title_color user-select-none'>
              {activateAlert.alertTitle}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="user-select-none">
            <b>{activateAlert.alertMsg}</b>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleAlertModalClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      }

      {showManifestBuildDialog ?
          <BuildManifest 
                    triggerRouteSuggestion={triggerRouteSuggestion} 
                    settriggerRouteSuggestion={settriggerRouteSuggestion} 
                    triggerUnRoute={triggerUnRoute} 
                    setTriggerUnRoute={setTriggerUnRoute}
                    GridRowData={selectRowData}
                    addTripRoute={route} 
                    setAddtoRoute={setAddTripToRoute} 
                    addtoRoute={addTripToRoute} 
                    showManifestBuildDialog={showManifestBuildDialog}
                    setManifestBuildDialog={setManifestBuildDialog}
                    selectedDate={selectedDate} 
                    setRouteSuggestionActionCreate={setRouteSuggestionActionCreate}
                    selectedAffiliates={selectedAffiliate} 
                    setGridRefreshPaused={setGridRefreshPaused}
                    bCallFromActivateTrip={true}
          />
      : ""}

      <ConfirmationModal show={confirmationModalObjReRouting.show} Title={confirmationModalObjReRouting.title} Body={confirmationModalObjReRouting.body}
                onOk={handleConfirmationModalReRoutingOk} onCancel={handleConfirmationModalReRoutingCancel} onClose={handleConfirmationModalReRoutingClose} btnCanceText={confirmationModalObjReRouting.btnCanceText}
                btnOkText={confirmationModalObjReRouting.btnOkText} ShowCancelButton="true" backdrop="static"/> 
      <ConfirmationModal show={confirmationModalObjTripActivationRefusal.show} Title={confirmationModalObjTripActivationRefusal.title} Body={confirmationModalObjTripActivationRefusal.body}
                onOk={handleConfirmationModalObjTripActivationRefusalOk} onCancel={handleConfirmationModalObjTripActivationRefusalCancel} onClose={handleConfirmationModalObjTripActivationRefusalClose} btnCanceText={confirmationModalObjTripActivationRefusal.btnCanceText}
                btnOkText={confirmationModalObjTripActivationRefusal.btnOkText} ShowCancelButton="false" />
           <ConfirmationModal show={confirmationModalObjReRoutingConfirmation.show} Title={confirmationModalObjReRoutingConfirmation.title} Body={confirmationModalObjReRoutingConfirmation.body}
                onOk={handleConfirmationModalReRoutingConfirmationOk} onCancel={handleConfirmationModalReRoutingConfirmationCancel} onClose={handleConfirmationModalReRoutingConfirmationClose} btnCanceText={confirmationModalObjReRoutingConfirmation.btnCanceText}
                btnOkText={confirmationModalObjReRoutingConfirmation.btnOkText} ShowCancelButton="false" backdrop="static"/>             
    </>
  );
};

export default ActivateTrip;
